/* tslint:disable */
var TrackingEventFpsAndMemoryUsage = /** @class */ (function () {
    function TrackingEventFpsAndMemoryUsage(args) {
        this.EVENT_ID = 131;
        this.data = args;
        this.data.eventId = this.EVENT_ID;
    }
    return TrackingEventFpsAndMemoryUsage;
}());
export { TrackingEventFpsAndMemoryUsage };
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/TrackingEventFpsAndMemoryUsage.ts
// module id = 1697
// module chunks = 3